import React from 'react'
import { useSelector } from 'react-redux';
import { Link, NavLink } from 'react-router-dom'
import icon1 from "../public/images/icons/telephone-white.svg"
import icon2 from "../public/images/icons/email-white.svg"
const Footer = () => {
   const {setting,footer_pages}=useSelector((state)=>state.SettingReducer);

  return (
    <div className='footer '>
      <div className='row  container-fluid ' style={{rowGap:'20px'}}>
         <div className='col-md-4'>
            <img src={setting.footer_logo} style={{height:'70px'}}/>
            <div className="d-flex gap-2 items-center my-4">
              <img src={icon1} />
              <div className="text-sm  text-white">{setting?.mobile}</div>
            </div>
            <div className="d-flex gap-2 items-center">
              <img src={icon2} />
              <div className="text-sm text-white">{setting?.email}</div>
            </div>
        </div>
         <div className='col-md-4 px-4'>
            <h3>من نحن</h3>
            <p className='footer-p' >{setting.description}</p>
         </div>
         <div className='col-md-4 px-4'>
            <h3>روابط مهمة</h3>
            <ul>
            {footer_pages.map((header_page)=>(
              <li key={header_page.id}>
            <NavLink  className={({ isActive }) =>
              `page-link ${
                isActive ? "page-link-hover" : ""
              } `
            } to={`/page/${header_page.term}/${header_page.id}`} >{header_page.name} </NavLink>
              </li>
            ))}

             
            </ul>
         </div>
      </div>
      <div>
      <ul className='social-media' >
                <li><a href={setting?.instagram}><i class="fa-brands fa-instagram"></i></a></li>
                {/* <li><a href='https://www.instagram.com/'><i class="fa-brands fa-twitter"></i></a></li> */}
                <li><a href={setting.facebook}><i class="fa-brands fa-facebook-f"></i></a></li>
                <li><a href={setting.youtube}><i class="fa-brands fa-youtube"></i></a></li>
             </ul>
      </div>
    </div>
  )
}

export default Footer
